import { gql } from '@collinsonx/utils/apollo';

const enrolLinkedAccountToAvailablePlans = gql`
  mutation EnrolLinkedAccountToAvailablePlans($linkedAccountID: ID!) {
    enrolLinkedAccountToAvailablePlans(linkedAccountID: $linkedAccountID)
  }
`;
export default enrolLinkedAccountToAvailablePlans;
